export const PERIOD_OPTIONS = [
  { value: "DAY", label: "Day" },
  { value: "WEEK", label: "Week" },
  { value: "MONTH", label: "Month" },
];

export const STATUS_COLOR = {
  ACTIVATED: "primary.7",
  NOT_ACTIVATED: "gray.5",
  PENDING: "yellow.6",
  IN_PROGRESS: "violet.6",
  COMPLETED: "primary.7",
  ESCALATED: "orange.6",
  CREATED: "blue.5",
  DEACTIVATED: "gray.5",
};

export const ROLES = ["ADMIN", "AML_MANAGER", "AUDITOR"];
